// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__1gDK7","body":"Page_body__3TTDm"};